import React from 'react';
import { abbrevNumber } from '../../common/utils';
import { RECORD_TYPE, PERCENT_TYPE, AMOUNT_TYPE } from '../constants';
var GaugeChartLabel = function (_a) {
    var _b = _a.value, value = _b === void 0 ? null : _b, units = _a.units, fontSize = _a.fontSize, chartWidth = _a.chartWidth, cy = _a.cy, labelFontSize = _a.labelFontSize;
    return (React.createElement("g", null,
        units === RECORD_TYPE &&
            React.createElement("text", { x: chartWidth / 2, y: cy - fontSize, fill: "#aaa", fontSize: labelFontSize, textAnchor: "middle" }, value === 1 ? 'record' : 'records'),
        units === AMOUNT_TYPE &&
            React.createElement("text", { x: chartWidth / 2, y: cy - fontSize, fill: "#aaa", fontSize: labelFontSize, textAnchor: "middle" }, "amount"),
        React.createElement("text", { x: chartWidth / 2, y: cy, fill: "#000", textAnchor: "middle", dominantBaseline: "top" },
            React.createElement("tspan", { fontSize: fontSize }, value !== null ? abbrevNumber(value) : 'N/A'),
            units === PERCENT_TYPE && React.createElement("tspan", { fill: "#aaa", fontSize: labelFontSize }, "%"))));
};
export default GaugeChartLabel;
//# sourceMappingURL=GaugeChartLabel.js.map